import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const clientService = {
    getAll,
    create,
    get,
    update,
    deleteClient,
    getClientDiseases,
    addClientDisease,
    updateClientDisease,
    deleteClientDisease,
    getDisaeseSubTypes,
    uploadAttachment,
    GetAttachments,
    getFileDescriptions,
    preDownloadAttachment,
    downloadAttachment,
    deleteAttachment,
    generateAgreeTemplate,
    getMedicalDocumentation,
    dodajWplateKredytu,
    getWplatyKredyty,
    deleteWplataKredytu,
    getWplatyKredytuXLSX,
    getProblemy,
    insertProblem,
    editProblem,
    deleteProblem,
    getProblem,
    getAllSMS
};

function getAll(data)
{
    return axios.get('/api/services/app/Client/GetAll', {
        params: {            
            QueryString: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            Sorting: data.sorting
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function create(data)
{
    return axios.post('/api/services/app/Client/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function get(id)
{
    return axios.get('/api/services/app/Client/Get', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })     
}
function update(data)
{
    return axios.put('/api/services/app/Client/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })    
}
function deleteClient(id)
{
    return axios.delete('/api/services/app/Client/Delete', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }           
    })    
}
function getClientDiseases(filters)
{
    return axios.get('/api/services/app/Client/GetClientDiseases', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: filters
    })
}
function addClientDisease(data)
{
    return axios.post('/api/services/app/Client/AddClientDisease',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateClientDisease(data)
{
    return axios.put('/api/services/app/Client/UpdateClientDisease',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteClientDisease(data)
{
    return axios.delete('/api/services/app/Client/DeleteClientDisease', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function getDisaeseSubTypes()
{
    return axios.get('/api/services/app/Client/GetDiseaseSubTypes', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function uploadAttachment(bodyData)
{
    let headers = authHeader()
    headers['Content-Type'] = 'multipart/form-data'
    return axios.post('/api/services/app/Client/UploadAttachment', bodyData, {
        baseURL: apiConfig.apiUrl,
        headers: headers
    })
}
function GetAttachments(id)
{
    return axios.get('/api/services/app/Client/GetAttachments', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            clientId: id
        }
    })
}
function getFileDescriptions()
{
    return axios.get('/api/services/app/Client/GetFileDescriptions', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function preDownloadAttachment(fingerprint)
{
    return axios.get('/api/services/app/Client/GetAttachmentDownload', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            fingerprint: fingerprint
        }
    })
}
function downloadAttachment(token)
{
    return axios({
        url: '/file/DownloadFile',
        params: { token: token},
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        responseType: 'blob',
        method: 'GET'
    })
}
function deleteAttachment(fingerprint)
{
    return axios.delete('/api/services/app/Client/DeleteAttachment', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            fingerprint: fingerprint
        }
    })

}
function generateAgreeTemplate(clientid, type)
{

    return axios.get('/api/services/app/Client/GetAgreeTemplate', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            clientId: clientid,
            type: type
        }
    })

}
function getMedicalDocumentation(clientid)
{
    return axios.get('/api/services/app/Client/GetDocumentation', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            clientId: clientid,
        }
    })
}
function dodajWplateKredytu(data)
{
    return axios.post('/api/services/app/Client/DodajWplateKredytu',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getWplatyKredyty(data)
{
    return axios.get('/api/services/app/Client/GetWplatyKredytu', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function deleteWplataKredytu(id)
{
    return axios.delete('/api/services/app/Client/DeleteWplataKredytu', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            wplataId: id
        }
    })
}
function getWplatyKredytuXLSX(clientid)
{
    return axios.get('/api/services/app/Client/GetWplatyKredytuXLSX', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            clientid: clientid,
        }
    })
}
function getProblemy(clientid)
{
    return axios.get('/api/services/app/Client/GetProblemy', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            clientid: clientid,
        }
    })

}
function insertProblem(data)
{
    return axios.post('/api/services/app/Client/InsertProblem',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function editProblem(data)
{
    return axios.post('/api/services/app/Client/EditProblem',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteProblem(id)
{
    return axios.delete('/api/services/app/Client/DeleteProblem', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function getProblem(id)
{
    return axios.get('/api/services/app/Client/GetProblem', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function getAllSMS(data)
{
    return axios.get('/api/services/app/Client/GetAllSMS', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}